import { render, staticRenderFns } from "./PermissionItemList.vue?vue&type=template&id=40091626&scoped=true&"
import script from "./PermissionItemList.vue?vue&type=script&lang=js&"
export * from "./PermissionItemList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionItemList.vue?vue&type=style&index=0&id=40091626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40091626",
  null
  
)

export default component.exports